import { Component, OnInit } from '@angular/core';
import { AslibGridComponent, IAslibModalOptions } from '@aslib/components';
import { BaseComponentService } from '../../services/base-component.service';

@Component({
  selector: 'gpa-empenho',
  templateUrl: './empenho.component.html',
  providers: [BaseComponentService],
  styles: [
    `
      .fieldRow {
      height:1px; border:none; color:#000; background-color:#000; margin-top: 0px; margin-bottom: 0px;'
      }
  `
  ]
})

export class EmpenhoComponent extends BaseComponentService implements OnInit {

  dataEnvioPed: string;
  arquivosPed: any[];
  arquivoPed: any;
  habilitarCarregar:boolean;
  projetoIntegrado: string;
  showTabsNavigation = false;

  ngOnInit() {
    this.dataEnvioPed = '';
    this.arquivosPed = [];
    this.arquivoPed = '';
    this.habilitarCarregar = true;

    sessionStorage.removeItem('IdPed');

    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
  }

  async getArquivoPed() {
    this.showTabsNavigation = false;
    sessionStorage.removeItem('IdPed');

    if (this.isNullOrUndefinedOrEmpty(this.dataEnvioPed)) {
      this.exibirAviso('Favor informar uma data para consulta dos PEDs.');
      return;
    }

    this.aslibLoadingService.start();

    try {
      await this.preencheComboDoisParametros('/api/PedEnvio/ObterInfoPedsEnviados/', 'arquivosPed',
          this.projetoIntegrado, this.dataEnvioPed, 'gpa');

      this.aslibLoadingService.complete();

      if (!this.arquivosPed || this.arquivosPed.length == 0) {
        this.exibirAviso('Não foram encontrados PEDs enviados para a data informada.');
        this.habilitarCarregar = true;
      } else {
        this.habilitarCarregar = false;
      }
    } catch (error) {
      this.aslibLoadingService.complete();
      this.exibirErro(error);
    }
  }

  emitterArquivoPed(fileId: number): void {
    if(this.arquivoPed === '') {
      this.exibirAviso('Selecione um arquivo para ser enviado.');
    } else {
      this.showTabsNavigation = false;
      setTimeout(() => {
        this.showTabsNavigation = true;
      }, 1000);
      sessionStorage.setItem ("IdPed", fileId.toString());
    }
  }

  openModalParametros(conteudo: any) {
    const options: IAslibModalOptions = {
      title: 'Parâmetros de Pagamento',
      backdrop: 'static',
      cancelarVisible: false,
      size: 'lg',
      content: conteudo
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/empenho.component.ts